import React, { Fragment, Suspense, lazy } from "react"
import { Route, Switch } from "react-router-dom"
import Loader from "./components/Loader/Loader"
import PublicKnowledgeBaseLayout from "./layouts/PublicKnowledgeBaseLayout"

export const renderRoutes = (routes = []) => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        {routes?.map((route, i) => {
          const Guard = route.guard || Fragment
          const Layout = PublicKnowledgeBaseLayout
          const Component = route.component

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  {
                    //  route.routes ? renderRoutes(route.routes) : <Component {...props} />
                    //  :
                    <Layout>
                      <Component {...props} />
                    </Layout>
                  }
                </Guard>
              )}
            />
          )
        })}
      </Switch>
    </Suspense>
  )
}

export const publicArticlesRoutePrefix = "/articles/public/"

export const getPublicKBArticlesPageRoute = (companySlug) => {
  return `${publicArticlesRoutePrefix}${companySlug}`
}

export const getPublicArticleDetailPageRoute = (companySlug, id) => {
  return `${publicArticlesRoutePrefix}${companySlug}/details/${id}`
}

const routes = () => [
  {
    exact: true,
    path: `/`,
    component: lazy(() => import("./views/PublicArticle/HomePage")),
  },
  {
    exact: true,
    path: `${publicArticlesRoutePrefix}:companySlug/`,
    component: lazy(() => import("./views/PublicArticle/PublicArticlesList")),
  },
  {
    exact: true,
    path: `${publicArticlesRoutePrefix}:companySlug/:publicKBUrl/`,
    component: lazy(() => import("./views/PublicArticle/PublicArticlesList")),
  },
  {
    exact: true,
    path: `${publicArticlesRoutePrefix}:companySlug/details/:id/`,
    component: lazy(() => import("./views/PublicArticle/PublicArticleDetail")),
  },
]

export default routes
